export enum UserType {
	nonMenber = 1,
	member = 2,
}
export enum MemberType {
	member = 1,
	noMember = 2,
}

export enum InformationType {
	information330 = 0,
	moreEmo = 1,
	FAQ = 2,
	aboutUs = 3,
}

export enum OnoffType {
	off = 0,
	on = 1,
	tobeOn = 2,
}

export enum ExerciseColor {
	AQUA = '0',
	ORANGE = '1',
	CORAL = '2',
	PINK = '3',
	PURPLE = '4',
	LAVENDER = '5',
	BLUE = '6',
	CX = '7',
	MTR = '8',
}

export enum SubjectType {
	Radio = 0,
	Multiple = 1,
	Linear = 2,
	Answer = 3,
}

export enum TaskStatus {
	PushOn = 0,
	PushOff = 1,
}

export enum Condition {
	OpenApp = 0,
	// Online = 1, // Temporarily hidden: This feature is not yet implemented in the app.
	Topage = 2,
	Exercise = 3,
	AssignAllExercise = 4,
	NewExercise = 5,
	Health = 6,
	ExerciseClock = 7,
	MajorExercise = 8,
	HeartExercise = 9,
	CrossoverExercise = 10,
	BodyExercise = 11,
	MeditationExercise = 12,
	Day21Exercise = 13,
	AllExercise = 14,
	ChangeEmail = 15,
	ChangePhone = 16,
	ChangeNickName = 17,
	ChangeProfile = 18,
}

export enum CountUnit {
	Time = 0,
	Minute = 1,
	Diff = 2,
	Day = 3,
}

export enum AwardType {
	Int = 0,
	Prop = 1,
	IntProp = 2,
}

export enum PropType {
	Treasure = 0,
	Mystery = 1,
}
export enum PropSeriesType {
	Card = 0,
	Chartlet = 1,
	Gallery = 2,
	Puzzle = 3,
	Email = 4,
	Mystery = 5,
}

export enum QualityType {
	Normal = 0,
	Rare = 1,
	Precious = 2,
	SuperPrecious = 3,
}

export enum RegularLoopType {
	Day = 0,
	Week = 1,
	Month = 2,
}

export enum ExerciseType {
	Day21 = 0,
	Meditation = 1,
	Body = 2,
	Crossover = 3,
	Major = 5,
	Addition = 6,
}

export enum AchievementCondition {
	MeditationTime = 0,
	DayTotal = 1,
	FinishHealth = 2,
	UseIntegral = 3,
	FinishDay21 = 4,
	FinishBody = 5,
	FinishMeditation = 6,
	FinishMajor = 7,
	FinishCrossover = 8,
	HeartExercise = 9,
	DrawBlindbox = 10,
	FinishAllExercise = 11,
	IntegralTotal = 12,
}

export enum AchievementTreasureCondition {
	Gallery = 0,
	Puzzle = 1,
	Email = 2,
	Card = 3,
	Chartlet = 4,
}

export enum TitleType {
	DayIntegralDesc = 0,
	IntegralDesc = 1,
}

export enum ShowTimeType {
	Every = 0,
	Once = 1,
	One = 2,
}

export enum DialogContentType {
	Image = 0,
	ImageText = 1,
	Video = 2,
}

export enum DialogClickToType {
	Null = 0,
	OutSide = 1,
	InSide = 2,
}

export enum DialogShowPage {
	WelcomePage = 0,
	Index = 1,
	Exercise = 2,
	Collect = 3,
	MyData = 4,
	Task = 5,
	Achievement = 6,
}

export enum DialogAssignPage {
	Index = 0,
	NowNeed = 1,
	Exercise = 2,
	Search = 3,
	Day21 = 4,
	MyData = 5,
	Setting = 6,
	Achievement = 7,
	Exchange = 8,
	Collect = 9,
	Record330 = 10,
	AboutUs = 11,
	MoreEmo = 12,
	QA = 13,
	Information330 = 14,
	Health = 15,
	Body = 16,
	Major = 17,
	Clock = 18,
	Task = 19,
}

export enum Platform {
	IOS = 'IOS',
	Android = 'Android',
}

export enum BoxType {
	SeriesBox = 0,
	MixtureBox = 1,
}

export enum BoxSeriesType {
	Gallery = 0,
	Puzzle = 1,
	Email = 2,
	Card = 3,
	Chartlet = 4,
}

export enum ChartletType {
	Dynamic = 0,
	Static = 1,
}
